// src/components/ui/Input.js
export default function Input({ label, error, ...props }) {
  return (
    <label className="block mb-3">
      <span className="block text-sm font-medium">{label}</span>
      <input
        {...props}
        className={`mt-1 w-full rounded-lg border px-3 py-2 ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      />
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
    </label>
  );
}
